/**
 * @FileDescription: 商机推荐
 * @Author: zhuangjinshan
 * @Date: 2025-12-25
 */
import axios from '@/api/utils/axios';
import BaseApi from '@/api/utils/baseApi.js'

const CommercialHallApi = {
	/**
	 * @description: 基础地址
	 */
	baseUrl: function() {
		return '/longstron/project/commercial/hall';
	},
  /**
	 * @description: 字段修改
	 * @param {String} id id
	 */
	updateField: function(id, data) {
		return axios.post(this.baseUrl() + "/updateField/" + id, data);
	},
  /**
	 * @description: 商机推荐
	 * @param {Object} data data
	 */
	listByType: function(data) {
		return axios.post(this.baseUrl() + "/listByType", data);
	},
};

export default Object.assign(CommercialHallApi, BaseApi);
